/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast.
 * In order to use this file you will need to open layout/theme.liquid
 * and uncomment the custom.js script import line near the bottom of the file.
 */

(function () {
  class GiftButtons extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.hasGiftCardCheckBox = this.querySelector("#has-gift-card");
      this.giftMessageWrapper = this.querySelector(".gift-message-wrapper");
      this.giftMessageTextarea = this.querySelector("#gift-message");
      this.charCountDisplay = this.querySelector("#char-count");
      this.realCartBtn = this.querySelector("[data-add-to-cart]");
      this.addGiftBtn = this.querySelector(".addGiftButton");

      this.relatedProductTitle = this.addGiftBtn?.getAttribute(
        "related-product-title"
      );

      this.maxLength =
        parseInt(this.giftMessageTextarea?.getAttribute("maxlength"), 10) ||
        200;

      if (
        !this.hasGiftCardCheckBox ||
        !this.giftMessageWrapper ||
        !this.giftMessageTextarea ||
        !this.addGiftBtn ||
        !this.realCartBtn
      )
        return;

      this.toggleGiftUI(this.hasGiftCardCheckBox.checked);

      this.hasGiftCardCheckBox.addEventListener("change", () => {
        this.toggleGiftUI(this.hasGiftCardCheckBox.checked);
      });

      this.giftMessageTextarea.addEventListener("input", () => {
        const original = this.giftMessageTextarea.value;
        const cleaned = original.replace(
          /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
          ""
        );

        if (original !== cleaned) {
          this.giftMessageTextarea.value = cleaned;
        }

        const charCount = cleaned.length;
        if (this.charCountDisplay) {
          this.charCountDisplay.textContent = `${charCount} / ${this.maxLength}`;
        }

        if (charCount > 0) {
          this.giftMessageTextarea.classList.remove("input-error");
        }
      });

      this.addGiftBtn.addEventListener("click", (e) => {
        e.preventDefault();

        const variantId = this.addGiftBtn.dataset.variantId;
        if (!variantId) return;

        const message = this.giftMessageTextarea?.value.trim();
        const hasEmoji =
          /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu.test(message);

        if (!message || hasEmoji) {
          this.giftMessageTextarea.classList.add("input-error");
          this.giftMessageTextarea.focus();
          alert("請輸入卡片內容（不能為空或包含 emoji）");
          return;
        }

        const properties = {
          賀卡內容: message,
        };

        if (this.relatedProductTitle) {
          properties["主商品"] = this.relatedProductTitle;
        }

        this.addGiftBtn.disabled = true;
        this.addGiftBtn.classList.add("loading");

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties,
          }),
        })
          .then((res) => res.json())
          .then(() => {
            this.realCartBtn.click();
          })
          .catch((err) => {
            console.error("加入贈品失敗：", err);
            alert("贈品加入失敗，請稍後再試！");
          })
          .finally(() => {
            this.addGiftBtn.disabled = false;
            this.addGiftBtn.classList.remove("loading");
          });
      });
    }

    toggleGiftUI(isChecked) {
      if (isChecked) {
        this.giftMessageWrapper.style.display = "flex";
        this.realCartBtn.classList.add("ako-pause");
        this.addGiftBtn.style.display = "block";
      } else {
        this.giftMessageWrapper.style.display = "none";
        this.giftMessageTextarea.value = "";
        this.giftMessageTextarea.classList.remove("input-error");

        if (this.charCountDisplay) {
          this.charCountDisplay.textContent = `0 / ${this.maxLength}`;
        }

        this.realCartBtn.classList.remove("ako-pause");
        this.addGiftBtn.style.display = "none";
      }
    }
  }

  customElements.define("ako-gift-buttons", GiftButtons);
})();
